module.exports = __webpack_public_path__ + "img/linkedin-d.5b238434.svg";